import React, {
  memo, useContext, useEffect, useRef
} from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import { CoachingBarState } from '../../types/coachingBar';
import { handleSlideDown } from '../../utils/coachingBarUtils';

type Props = {
  bodyRef: React.MutableRefObject<HTMLElement>;
  coachingBarState: CoachingBarState;
  setCoachingBarState: Function;
}

const WelcomeBackPopup = (props: Props): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const welcomeBackPopupRef = useRef(null);
  const closetCountRequired = props.coachingBarState.closetCountRequired;
  const isMobile = globalContext.gb.utils.checkDevice('mobile');
  const handleWelcomeBackAddMoreToClosetBtn = (): void => {
    globalContext.gtm.pushVersionedEvent('2.x', 'CoachingBar', 'ClickXMoreToClosetButton', 'x = ' + closetCountRequired);

    // hides WelcomeBackPopup with slideDown Animation
    if (welcomeBackPopupRef.current) {
      handleSlideDown(welcomeBackPopupRef, 15);
    }

    setTimeout(() => {
      props.setCoachingBarState({
        ...props.coachingBarState,
        displayWelcomeBackPopup: false,
        displayCoachingPopup: false
      });
    }, 500);
    props.bodyRef.current.classList.remove('stop-scroll');
  };
  const setWelcomeBackPopupVirtalPage = (): void => {
    globalContext.gtm.setVirtualPage('New_Subscriber_Onboarding_Coaching_Bar_Re_Entry');
  };

  useEffect(() => {
    setWelcomeBackPopupVirtalPage();

    if (isMobile && props.coachingBarState.displayCoachingBar) {
      window.scrollTo(0, 0);
      props.bodyRef.current.classList.add('stop-scroll');
    } else if (props.coachingBarState.displayCoachingBar) {
      props.bodyRef.current.classList.add('stop-scroll');
    }
  }, []);

  const welcomeBackHeading = globalContext.i18n.getText('improved_sub_onboarding_welcome_back_popup_heading');
  const welcomeBackMessage = globalContext.i18n.getText('improved_sub_onboarding_welcome_back_popup_msg', { closetCountRequired: closetCountRequired });
  const AddMoreToClosetBtnText = globalContext.i18n.getText('improved_sub_onboarding_welcome_back_popup_add_more_cta_text', { closetCountRequired: closetCountRequired });

  return (
    <div className="coaching-popup coaching-popup--welcome js-coaching-popup"
    ref={welcomeBackPopupRef}>
        <div className="coaching-popup__inner">
            <h2 className="coaching-popup__heading">{welcomeBackHeading}</h2>
            <p className="coaching-popup__message">{welcomeBackMessage}</p>
        </div>
        <div className="coaching-popup__outer">
            <div className="coaching-bar__popup-buttons">
                <button
                className="base-button base-button--medium base-button--activation coaching-popup__btn js-add-more-closet-btn"
                style={{ marginBottom: 0 }}
                onClick={handleWelcomeBackAddMoreToClosetBtn}>
                  {AddMoreToClosetBtnText}
                </button>
            </div>
        </div>
    </div>
  );
};

export default memo(WelcomeBackPopup);
